import { Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import SteLib from 'src/lib/stelib';
import { basename } from '../configs/EnvironmentConfig';
import moment from 'moment';

export default function SponsorPage({setToken}) {
  const [firstTime, setFirstTime] = useState(true);
  const [sponsorsImages, setSponsorsImages] = useState([])
  const sponsorsDirectory = '/images/sponsors';

  useEffect(() => {
    if(firstTime)
    {
      SteLib.SimpleGet(basename+"/images/sponsors/sponsors.json?timestamp="+moment().valueOf()).then((data) => {
        setSponsorsImages(data)
      })
    }
    setFirstTime(false);
  }, [firstTime]);

  return (
    <>
        <Stack alignContent={"center"} style={{padding: "0 2rem"}}>
            <div style={{textAlign: "center"}}>
              <h2><b>SPONSOR</b></h2>
              I nostri Sponsor:
            </div>
            <br/><br/>

            <Stack style={{display: "flex", alignContent: "center", flexWrap:"wrap"}}>
                {sponsorsImages.map((imageName, index) => (
                  <><img style={{width: "25rem"}} src={`${process.env.PUBLIC_URL}${sponsorsDirectory}/${imageName}`}></img>
                  <br/><br/><br/><br/></>
                ))}
            </Stack>
          </Stack>
    </>
  );
}
